<template>
  <div>
    <ContentHeader title="Agent Request" />
    <table-skeleton v-if="loading"></table-skeleton>
    <section class="content" v-else>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="row w-100">
                  <div class="col-md-6">
                    
                  </div>
                  <div class="col-md-6 d-flex justify-content-end">
                    <div class="input-group input-search">
                      <input
                        type="text"
                        name="search"
                        class="form-control"
                        placeholder="Search"
                        v-model="table.filter"
                      />

                      <div class="input-group-append">
                        <button type="submit" class="btn btn-default">
                          <i class="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  :items="ibr"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  :filter-included-fields="[
                    'ib_level',
                    'min_investor',
                    'min_deposit',
                  ]"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  <template v-slot:cell(investor)="data">
                      {{data.item.investor.name}}
                    
                  </template>
                  <template v-slot:cell(level)="data">
                    <span
                      v-if="!data.item.level"
                      class="badge badge-pill badge-danger"
                      >EMPTY</span
                    >
                    <span
                      v-else-if="data.item.level == 'PARTNER_IB'"
                      class="badge badge-pill badge-info"
                      >Supervisor Area</span
                    >
                    <span
                      v-else-if="data.item.level == 'INTRODUCING_BROKER'"
                      class="badge badge-pill badge-warning"
                      >Agent Level</span
                    >
                    <span
                      v-else-if="data.item.level == 'MASTER_IB'"
                      class="badge badge-pill badge-success"
                      >Manager Area</span
                    >
                    <span
                      v-else-if="data.item.level == 'SUB_PARTNER_IB'"
                      class="badge badge-pill badge-info"
                      >SUB Supervisor Area</span
                    >
                  </template>
                  <template v-slot:cell(updated_at)="data">
                    {{ new Date(data.item.updated_at).toUTCString() }}
                  </template>
                  <template v-slot:cell(admission_status)="data">
                    <div class="btn btn-warning rounded-pill" v-if="data.value == 'PENDING'">
                      PENDING
                    </div>
                    <div class="btn btn-success rounded-pill" v-else-if="data.value == 'APPROVED'">
                      APPROVED
                    </div>
                    <div class="btn btn-danger rounded-pill" v-else-if="data.value == 'REJECTED'">
                      REJECTED
                    </div>
                  </template>
                  <template v-slot:cell(Action)="data">
                    <b-button style="background-color:transparent; border:0px;" @click="datamodal(data.item.id)" v-b-modal.modal-status>
                      <i class="fas fa-pencil-alt text-info"></i>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal id="modal-status" size="md" hide-footer>
      <div class="container-fluid">
        <h4 class="w-75" style="margin:0 auto;text-align:center;">Are You Sure to Change Status Pending to Approved?</h4>
        <form class="mt-md-4" @submit.prevent="editstatus">
          
            <select aria-placeholder="okeoce" class="form-select" v-model="datasubscription.status" aria-label="Default select example">
              <option :value="''" disabled selected>Please select an Status</option>
              <option value="APPROVED">APPROVED</option>
              <option value="REJECTED">REJECTED</option>
            </select>
          <!-- <span style="text-align:center;">Are You Sure to Change Status Pending to Installed?</span> -->
          <!-- <div class="mb-3">
                <b-calendar block v-model="datasubscription.date" :min="min" :max="max" locale="en"></b-calendar>
            </div> -->
            <!-- <input type="text" v-model="datasubscription.cekdata"> -->
            
          <div class="float-right">
            <b-button class="mt-md-4 btn-cancel mr-3 btn" @click="$bvModal.hide('modal-status')">Cancel</b-button>
            <button id="edit-sub" type="submit" class="btn btn-danger mt-md-4">Yes</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TableSkeleton from "@/components/loading-screen/TableSkeleton.vue";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiIb from "../../services/ApiServicesIB";

export default {
  components: {
    ContentHeader,
    TableSkeleton
  },

  data() {
    return {
      
        loading: false,
      ibr: [],
      datasubscription:{
        id:'',
        status:''
      },
      datastatus:[
        {status:"APPROVED"},
        {status:"REJECTED"}
      ],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "Investor",
            sortable: true,
          },
          {
            key: "level",
            sortable: true,
            label: 'Requested Level',
          },
          {
            key: "updated_at",
            sortable: true,
            label: 'Date',
          },
          {
            key: "admission_status",
            sortable: true,
            label: 'Status',
          },
          "Action",
        ],
      },
    };
  },
  created() {
    document.title = "List Configuration - Manager Cabang";
  },

  async mounted() {
    try {
      let ibRequest = await apiIb.get(
        `?corporate_id=${this.$user_id}&admission_status=PENDING`
      );
      this.ibr = ibRequest.data.data.sort(function (a, b) {
        return (
          new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
        );
      });
      this.table.totalRows = this.ibr.length;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },

  methods: {
    setState(state){
      this.ngecekdata = state.status
      console.log(state.status)
      
      },
    datamodal(dataid,datacreated){
      this.datasubscription.id = dataid
      this.datasubscription.status = ''
      this.min = datacreated
      
      this.max = new Date()
    },
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
    logout() {
      this.$store.dispatch("logout");
    },
    editstatus(){
      console.log(this.datasubscription.status.toString())
    document.getElementById("edit-sub").disabled = true
    let data = new FormData()
    data.append('admission_status', this.datasubscription.status.toString())
    // data.append('active_date', this.datasubscription.date)
    apiIb.put(`${this.datasubscription.id}/`, data)
    .then((response) => {
        if(response.data.status === 200) {
          this.loading = true
          this.$bvModal.hide('modal-status')
           this.$swal(
              "Congratulation!!!",
              "Data Introsuctin Status successfully Edit.",
              "success"
            )
            apiIb.get(
              `?corporate_id=${this.$user_id}&admission_status=PENDING`
            ).then(response =>{
            this.ibr = response.data.data
            this.table.totalRows = this.ibr.length;
              this.loading = false
            }).catch(() => {
            })
         
          document.getElementById("edit-sub").disabled = false
          

          
        } else {
          document.getElementById("edit-sub").disabled = false
            // validation.value = response.data.response
        }
    }).catch(() => {
        document.getElementById("edit-sub").disabled = false
        
        
    })
    }
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .add-button {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.input-search {
  width: 250px;
}
</style>
